import type { City } from '@/types/domain';

export const mockCities: City[] = [
  { slug: 'lisbon', name_ua: 'Лісабон', region: 'Лісабон' },
  { slug: 'porto', name_ua: 'Порту', region: 'Норте' },
  { slug: 'algarve', name_ua: 'Алгарве', region: 'Алгарве' },
  { slug: 'braga', name_ua: 'Брага', region: 'Норте' },
  { slug: 'coimbra', name_ua: 'Коімбра', region: 'Центру' },
  { slug: 'setubal', name_ua: 'Сетубал', region: 'Лісабон' },
  { slug: 'aveiro', name_ua: 'Авейру', region: 'Центру' },
  { slug: 'faro', name_ua: 'Фару', region: 'Алгарве' },
  { slug: 'cascais', name_ua: 'Кашкайш', region: 'Лісабон' },
];
